const info = {
    $schema: "../../assetlist.schema.json",
    chain_name: "tucana",
    assets: [
        {
            description: "The native token of Initia",
            denom_units: [
                {
                    denom: "l2/333f8e6ae6855338f99d451126bfefc1b920763c16681d55fbc7df68ccb36972",
                    exponent: 0,
                },
                {
                    denom: "INIT",
                    exponent: 6,
                },
            ],
            base: "l2/333f8e6ae6855338f99d451126bfefc1b920763c16681d55fbc7df68ccb36972",
            display: "INIT",
            name: "Initia Native Token",
            symbol: "INIT",
            coingecko_id: "",
            traces: [
                {
                    type: "op",
                    counterparty: {
                        base_denom: "uinit",
                        chain_name: "initia",
                    },
                    chain: {
                        bridge_id: "14",
                    },
                },
            ],
            images: [
                {
                    png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/INIT.png",
                    svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/INIT.svg",
                },
            ],
            logo_URIs: {
                png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/INIT.png",
                svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/INIT.svg",
            },
        },
        {
            description: "The native token of Tucana",
            denom_units: [
                {
                    denom: "utuc",
                    exponent: 0,
                },
                {
                    denom: "TUC",
                    exponent: 6,
                },
            ],
            base: "utuc",
            display: "TUC",
            name: "Tucana Native Token",
            symbol: "TUC",
            coingecko_id: "",
            images: [
                {
                    png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/tucana/images/TUCANA.png",
                    svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/tucana/images/TUCANA.svg",
                },
            ],
            logo_URIs: {
                png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/tucana/images/TUCANA.png",
                svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/tucana/images/TUCANA.svg",
            },
        },
        {
            description: "The LP token of Tucana",
            denom_units: [
                {
                    denom: "move/17bf475fe65c54864db2ba45883b8d3fa198d80e4edd31088fd41d505075080b",
                    exponent: 0,
                },
                {
                    denom: "TLP",
                    exponent: 6,
                },
            ],
            base: "move/17bf475fe65c54864db2ba45883b8d3fa198d80e4edd31088fd41d505075080b",
            display: "TLP",
            name: "Tucana Perps LP",
            symbol: "TLP",
            coingecko_id: "",
            images: [
                {
                    png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/tucana/images/TUCANA-PERP.png",
                    svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/tucana/images/TUCANA-PERP.svg",
                },
            ],
            logo_URIs: {
                png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/tucana/images/TUCANA-PERP.png",
                svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/tucana/images/TUCANA-PERP.svg",
            },
        },
        {
            description: "The fake ETH",
            denom_units: [
                {
                    denom: "ibc/0E98D4D1D907597448FD3A7C33DDAE10A90FA86FC8A9F5A0B175393783F249CD",
                    exponent: 0,
                },
                {
                    denom: "ETH",
                    exponent: 6,
                },
            ],
            base: "ibc/0E98D4D1D907597448FD3A7C33DDAE10A90FA86FC8A9F5A0B175393783F249CD",
            display: "ETH",
            name: "Fake ETH Token",
            symbol: "ETH",
            coingecko_id: "",
            traces: [
                {
                    type: "ibc",
                    counterparty: {
                        chain_name: "initia",
                        base_denom: "ueth",
                        channel_id: "channel-25",
                    },
                    chain: {
                        channel_id: "channel-0",
                        path: "transfer/channel-0/ueth",
                    },
                },
            ],
            images: [
                {
                    png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/ETH.png",
                    svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/ETH.svg",
                },
            ],
            logo_URIs: {
                png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/ETH.png",
                svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/ETH.svg",
            },
        },
        {
            description: "The fake USDC",
            denom_units: [
                {
                    denom: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
                    exponent: 0,
                },
                {
                    denom: "USDC",
                    exponent: 6,
                },
            ],
            base: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
            display: "USDC",
            name: "USDC",
            symbol: "USDC",
            coingecko_id: "",
            traces: [
                {
                    type: "ibc",
                    counterparty: {
                        chain_name: "initia",
                        base_denom: "uusdc",
                        channel_id: "channel-25",
                    },
                    chain: {
                        channel_id: "channel-0",
                        path: "transfer/channel-0/uusdc",
                    },
                },
            ],
            images: [
                {
                    png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/minimove/images/USDC.png",
                    svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/minimove/images/USDC.svg",
                },
            ],
            logo_URIs: {
                png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/minimove/images/USDC.png",
                svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/minimove/images/USDC.svg",
            },
        },
        {
            description: "The fake TIA",
            denom_units: [
                {
                    denom: "ibc/C3E53D20BC7A4CC993B17C7971F8ECD06A433C10B6A96F4C4C3714F0624C56DA",
                    exponent: 0,
                },
                {
                    denom: "TIA",
                    exponent: 6,
                },
            ],
            base: "ibc/C3E53D20BC7A4CC993B17C7971F8ECD06A433C10B6A96F4C4C3714F0624C56DA",
            display: "TIA",
            name: "Fake TIA Token",
            symbol: "TIA",
            coingecko_id: "",
            traces: [
                {
                    type: "ibc",
                    counterparty: {
                        chain_name: "initia",
                        base_denom: "utia",
                        channel_id: "channel-25",
                    },
                    chain: {
                        channel_id: "channel-0",
                        path: "transfer/channel-0/utia",
                    },
                },
            ],
            images: [
                {
                    png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/TIA.png",
                    svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/TIA.svg",
                },
            ],
            logo_URIs: {
                png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/TIA.png",
                svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/initia/images/TIA.svg",
            },
        },
        {
            description: "MilkyWay IBC bridged milkINIT",
            denom_units: [
                {
                    denom: "ibc/22D8C3F45607B466D8691E308F9CF86729DAFCBE94BB1FC89F3511FE24E848E2",
                    exponent: 0,
                },
                {
                    denom: "milkINIT",
                    exponent: 6,
                },
            ],
            base: "ibc/22D8C3F45607B466D8691E308F9CF86729DAFCBE94BB1FC89F3511FE24E848E2",
            display: "milkINIT",
            name: "MilkyWay IBC milkINIT",
            symbol: "milkINIT",
            coingecko_id: "",
            traces: [
                {
                    type: "ibc",
                    counterparty: {
                        chain_name: "milkyway",
                        base_denom: "milkuinit",
                        channel_id: "channel-0",
                    },
                    chain: {
                        channel_id: "channel-310",
                        path: "transfer/channel-310/milkuinit",
                    },
                },
                {
                    type: "ibc",
                    counterparty: {
                        chain_name: "initia",
                        base_denom: "ibc/26939E676F967B14E319631A9A42233148BBC7F7CEFDCBD347447AF0AE37B1AD",
                        channel_id: "channel-25",
                    },
                    chain: {
                        channel_id: "channel-0",
                        path: "transfer/channel-0/transfer/channel-310/milkuinit",
                    },
                },
            ],
            images: [
                {
                    png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/milkyway/images/milkINIT.png",
                    svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/milkyway/images/milkINIT.svg",
                },
            ],
            logo_URIs: {
                png: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/milkyway/images/milkINIT.png",
                svg: "https://raw.githubusercontent.com/initia-labs/initia-registry/main/testnets/milkyway/images/milkINIT.svg",
            },
        },
    ],
};
export default info;
